import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import logo from '../../../include/images/mindy-logo.svg'
import logOut from '../../../include/images/logout-icon.svg'
import notificationIcon from '../../../include/images/notifications-icon.svg'
import colurBell from '../../../include/images/bell-solid (1).svg'
import downArrow from '../../../include/images/small-down.svg'
import { getAppointment } from '../../../store/appointment'
import { getDoctor, loadDoctorProfile, loadDoctorProfileForStaff } from '../../../store/doctor'
import { loadSeo } from '../../../store/seo'
import { clearAllToken } from '../../services/localStorageServices'
import { Link } from 'react-router-dom'
import {
  getNotification,
  loadCountNotification,
} from '../../../store/notification'
import { getChats } from '../../../store/chats'
import ShareProfile from '../../common/shareProfile'

class Header extends Component {
  state = {
    dropDown: false,
    intervalId: 1,
    staffProfile: localStorage.getItem('staffProfile')
      ? JSON.parse(localStorage.getItem('staffProfile'))
      : false,
    showMessage: false,  
    showShareModal: false,  
  }

  toggleDropdown = (e) => {
    e.stopPropagation()
    e.preventDefault()
    this.setState({ dropDown: !this.state.dropDown })
  }

  logout = (e) => {
    e.preventDefault()
    clearAllToken()
    window.location.href = '/'
  }

  toggleShareModal = () => {
    this.setState(prevState => ({
      showShareModal: !prevState.showShareModal,
    }))
  }

  componentDidMount = () => {
  const path = this.props.history.location.pathname
  const isStaff = path.startsWith('/staff')
    if(isStaff){
    this.props.loadDoctorProfileForStaff()
    } else {
    this.props.loadCountNotification()
    this.props.loadDoctorProfile()
    var intervalId = setInterval(() => this.props.loadCountNotification(), 5000)
    this.setState({ intervalId })      
    }
  }

  componentWillUnmount = () => {
    clearInterval(this.state.intervalId)
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (
      !this.props.profileLoading &&
      this.props.profileLoadin !== prevProps.profileLoading
    ) {
      if (!this.props.doctorProfile.is_approved)
        this.props.history.push('/doctor/sign-up/personal-detail')
    }
  }

  render() {
    const { name, image_url } = this.props.doctorProfile
    return (
      <div
        class="dashboard-top-bar"
        onClick={(e) => {
          e.stopPropagation()
          this.setState({ dropDown: false })
        }}
      >
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 d-flex align-items-center">
              <div
                onClick={this.props.toggleSidebar}
                class={
                  this.props.sidebarToogle ? 'menu-toggle on' : 'menu-toggle'
                }
              >
                <div class="one"></div>
                <div class="two"></div>
                <div class="three"></div>
              </div>

              <div class="logo-area">
                <Link
                  to={
                    this.props.history.location.pathname.split('/')[1] ===
                    'staff'
                      ? '/staff/dashboard'
                      : '/doctor/dashboard'
                  }
                  class="navbar-brand"
                >
                  <img src={logo} alt="" />
                </Link>
              </div>

              <div class="dtb-mid d-md-flex align-items-md-center">
                <h2 class="flex-grow-1">
                  Welcome,{' '}
                  <strong>
                    {this.state.staffProfile
                      ? this.state.staffProfile.first_name +
                        ' ' +
                        this.state.staffProfile.last_name
                      : name}
                  </strong>
                </h2>
              </div>

              <div class="dtb-right ml-auto">
                <ul class="nav">
                  {this.props.history.location.pathname.split('/')[1] !==
                    'staff' && (
                    <>
                    <li>
                      <div
                        className="notification-box"
                        onClick={this.toggleShareModal}
                        style={{
                          position: "relative",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "2px",
                          cursor: "pointer",
                        }}
                      >
                        <i
                          className="fa-sharp-duotone fa-xl fa-lgfa-solid fa-circle-share-nodes"
                          style={{
                            "--fa-primary-color": "rgb(255, 255, 255)",
                            "--fa-secondary-color": "#03ac60",
                            "--fa-secondary-opacity": "0.94",
                          }}
                        ></i>

                        <span className="d-none d-lg-block">
                          Share my Profile
                        </span>
                      </div>
                    </li>
                    <li>
                      <div
                        className="notification-box"
                        onClick={() =>
                          this.setState({
                            showMessage: !this.state.showMessage,
                          })
                        }
                        style={{
                          position: "relative",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "2px",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          style={{
                            position: "relative",
                            display: "inline-block",
                          }}
                        >
                          <i
                            className="fa-utility-fill fa-semibold fa-comments fa-lg"
                            style={{
                              color:
                                this.props.chats.unreadPatientIds?.length > 0
                                  ? "#8BB044"
                                  : "rgb(194, 190, 201)",
                            }}
                          ></i>

                          {this.props.chats.unreadPatientIds?.length > 0 && (
                            <span
                              style={{
                                position: "absolute",
                                top: "-10px",
                                right: "-10px",
                                backgroundColor: "#ff5d30fc",
                                color: "#fff",
                                borderRadius: "50%",
                                minWidth: "18px",
                                height: "18px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "11px",
                                fontWeight: "bold",
                                lineHeight: "18px",
                                padding: "0 4px",
                              }}
                            >
                              {this.props.chats.unreadPatientIds.length > 9
                                ? "9+"
                                : this.props.chats.unreadPatientIds.length}
                            </span>
                          )}
                        </div>

                        <span className="d-none d-lg-block"
                          style={{
                            color:
                              this.props.chats.unreadPatientIds?.length > 0
                                ? "#8BB044"
                                : "inherit",
                          }}>
                          Messages
                        </span>

                        {this.state.showMessage && (
                          <div
                            style={{
                              position: "absolute",
                              top: "35px",
                              right: "0",
                              background: "#f5f3f8",
                              color: "#582bb8",
                              padding: "8px 10px",
                              borderRadius: "12px 0 12px 12px",
                              boxShadow: "0 3px 12px rgba(0,0,0,0.2)",
                              zIndex: 9999,
                              fontSize: "13px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Check messages from home section of your dashboard under chats
                          </div>
                        )}
                      </div>
                    </li>
                    <li>
                      <Link
                        to="/doctor/notification"
                        className="notification-box"
                        style={{
                          position: "relative",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "2px",
                        }}
                      >
                        <div
                          style={{
                            position: "relative",
                            display: "inline-block",
                          }}
                        >
                          <i
                            className="fa-sharp-duotone fa-solid fa-bell fa-lg"
                            style={{
                              color: this.props.notificationcount.countUnRead
                                ? "#8BB044"
                                : "inherit",
                            }}
                          ></i>

                          {this.props.notificationcount.countUnRead > 0 && (
                            <span
                              style={{
                                position: "absolute",
                                top: "-10px",
                                right: "-10px",
                                backgroundColor: "#ff5d30fc",
                                color: "#fff",
                                borderRadius: "50%",
                                minWidth: "18px",
                                height: "18px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "11px",
                                fontWeight: "bold",
                                lineHeight: "18px",
                                padding: "0 4px",
                              }}
                            >
                              {this.props.notificationcount.countUnRead > 9
                                ? "9+"
                                : this.props.notificationcount.countUnRead}
                            </span>
                          )}
                        </div>

                        <span
                          className="d-none d-lg-block"
                          style={{
                            color: this.props.notificationcount.countUnRead
                              ? "#8BB044"
                              : "inherit",
                          }}
                        >
                          Notifications
                        </span>
                      </Link>
                    </li>
                    </>
                  )}

                  <li>
                    <div class="custom-menu">
                      <div>
                        <a
                          href="#!"
                          class="profile-menu-box"
                          onClick={this.toggleDropdown}
                        >
                          <div class="profile-text-box d-none d-lg-block">
                            {name}
                            <img src={downArrow} alt="" />
                          </div> 
                            <div class="profile-img">
                              <img
                                src={
                                  image_url
                                    ? process.env.REACT_APP_S3URL + image_url
                                    : ''
                                }
                              />
                            </div> 
                        </a>

                        <div
                          class={
                            this.state.dropDown
                              ? 'custom-dropdown show'
                              : 'custom-dropdown'
                          }
                        >
                          <ul class="menu-list"> 
                              <>
                                <li>
                                  <Link to="/doctor/sign-up/personal-detail">
                                    Profile Information
                                  </Link>
                                </li>
                                <li>
                                  <a href="/">Visit Site</a>
                                </li>
                              </> 
                            <li>
                              <a href="#!" onClick={this.logout}>
                                <b>
                                  <img src={logOut} alt="" />
                                  Logout
                                </b>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <ShareProfile
          name={name}
          username={this.props.doctorProfile.user_name}
          showShareModal={this.state.showShareModal}
          toggleShareModal={this.toggleShareModal}
        />
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadSeo: (page_key) => dispatch(loadSeo(page_key)),
  loadCountNotification: () => dispatch(loadCountNotification()),
  loadDoctorProfile: () => dispatch(loadDoctorProfile()),
  loadDoctorProfileForStaff: () => dispatch(loadDoctorProfileForStaff()),
})
const mapStateToProps = (state) => ({
  profileLoading: getDoctor(state).profileLoading,
  doctorProfile: getDoctor(state).profile,
  notificationcount: getNotification(state).count,
  chats: getChats(state),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header))
